export class CampaignsMetricsBuilder {
    constructor() {
        this.metrics = {};
    }

    setEngagements(engagements){
        this.metrics.engagements = engagements;
        return this;
    }

    setLikes(likes) {
        this.metrics.likes = likes;
        return this;
    }

    setReplies(replies){
        this.metrics.replies = replies;
        return this;
    }

    setFollows(follows) {
        this.metrics.follows = follows;
        return this;
    }


    build(){
        return this.metrics;
    }
}